import React from 'react';
import {
  Box,
  ColumnLayout,
  Container,
  Header,
  SpaceBetween,
  Table,
  TextContent,
  ProgressBar
} from '@cloudscape-design/components';

// Dummy data for confidence scores
const confidenceScores = [
  { label: 'Technical Analysis', value: 87 },
  { label: 'Domain Analysis', value: 92 },
  { label: 'Code Generation', value: 85 }
];

// Dummy data for recent AI validations
const recentValidations = [
  { file: 'UserService.java', confidence: 94, manualEdits: 2 },
  { file: 'OrderDomain', confidence: 88, manualEdits: 5 },
  { file: 'PaymentService.java', confidence: 76, manualEdits: 8 },
  { file: 'ProductCatalog', confidence: 91, manualEdits: 1 },
  { file: 'InventoryManager.java', confidence: 82, manualEdits: 4 }
];

const ConfidenceBar = ({ label, value }) => (
  <Box>
    <TextContent>
      <h3>{label}</h3>
    </TextContent>
    <ProgressBar 
      value={value}
      label={`${value}%`}
      description="Confidence Score"
    />
  </Box>
);

const AIEffectivenessView = () => {
  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Overview of AI performance and recent validations"
        >
          AI Effectiveness
        </Header>
      }
    >
      <SpaceBetween size="l">
        {/* Confidence Score Bars */}
        <ColumnLayout columns={1} variant="text-grid">
          {confidenceScores.map((score, index) => (
            <ConfidenceBar key={index} label={score.label} value={score.value} />
          ))}
        </ColumnLayout>

        {/* Recent AI Validations Table */}
        <Table
          columnDefinitions={[
            {
              id: 'file',
              header: 'File/Domain',
              cell: item => item.file,
              sortingField: 'file'
            },
            {
              id: 'confidence',
              header: 'Confidence',
              cell: item => `${item.confidence}%`,
              sortingField: 'confidence'
            },
            {
              id: 'manualEdits',
              header: 'Manual Edits',
              cell: item => item.manualEdits,
              sortingField: 'manualEdits'
            }
          ]}
          items={recentValidations}
          loadingText="Loading validations"
          sortingColumn={{ sortingField: 'confidence', sortingDescending: true }}
          header={
            <Header
              variant="h3"
              counter={`(${recentValidations.length})`}
            >
              Recent AI Validations
            </Header>
          }
          variant="container"
          stickyHeader
          stripedRows
        />

        {/* Summary Statistics */}
        <ColumnLayout columns={3} variant="text-grid">
          <TextContent>
            <h4>Average Confidence</h4>
            <p>{(confidenceScores.reduce((sum, score) => sum + score.value, 0) / confidenceScores.length).toFixed(1)}%</p>
          </TextContent>
          <TextContent>
            <h4>Total Validations</h4>
            <p>{recentValidations.length}</p>
          </TextContent>
          <TextContent>
            <h4>Avg Manual Edits</h4>
            <p>{(recentValidations.reduce((sum, item) => sum + item.manualEdits, 0) / recentValidations.length).toFixed(1)}</p>
          </TextContent>
        </ColumnLayout>
      </SpaceBetween>
    </Container>
  );
};

export default AIEffectivenessView;
